/** Reference used to store urls */
export const urls = {
    libreSharingApiUrl: '',
    lvapiCountryURL: '',
    libreApiCountryUrl: '',
    libreSharingApiCountryUrl: '',
};
/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config, country) => {
    const { libreSharingApiUrl, lvapiURL, libreApiUrl, libreApiCountryUrls, lvApiCountryUrls, libreSharingApiCountryUrls, } = config;
    Object.assign(urls, {
        libreSharingApiUrl,
        lvapiCountryURL: country && lvApiCountryUrls ? lvApiCountryUrls[country] : lvapiURL,
        libreApiCountryUrl: country && libreApiCountryUrls ? libreApiCountryUrls[country] : libreApiUrl,
        libreSharingApiCountryUrl: country && libreSharingApiCountryUrls
            ? libreSharingApiCountryUrls[country]
            : libreSharingApiUrl,
    });
};
export const getDocumentPathFromLanguage = (document, lang) => {
    if (!document) {
        return '';
    }
    const path = document[lang.toLowerCase()] || document.default || document['en-us'];
    return path;
};
export const detectTheme = (urlParams) => {
    const productParam = urlParams.get('product');
    // temporarily disable dark mode
    // const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'Dark' : 'Light';
    const theme = 'Light';
    return !productParam || productParam === 'libre1' ? `polaris${theme}` : `otc${theme}`;
};
export const getTheme = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const themeParam = urlParams.get('theme');
    return themeParam ? themeParam : detectTheme(urlParams);
};
export const generateUserAgentHeader = (app, appVersion, osType, osVersion) => {
    return `${app ? app : 'none'};${appVersion ? appVersion : 'none'};${osType ? osType : 'none'};${osVersion ? osVersion : 'none'}`;
};
export const cutString = (value, limit) => {
    if (!value) {
        return '';
    }
    return value.length > limit ? `${value.slice(0, limit)}...` : value;
};
export const generateLibreUserAgentHeader = (app, appVersion, osType, osVersion) => {
    return `${app ?? 'none'};${appVersion ?? 'none'};${osType ?? 'none'};${osVersion ?? 'none'}`;
};
export const applyPhoneNumberMask = (phoneNumber) => {
    if (!phoneNumber) {
        return '';
    }
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // US Only atm
};
